// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout {\n  background: var(--gray6);\n  min-height: 100vh;\n}\n.layout .container-fluid {\n  max-width: 1350px;\n}", "",{"version":3,"sources":["webpack://src/components/Layout/_layout.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,iBAAA;AACF;AACE;EACE,iBAAA;AACJ","sourcesContent":[".layout {\n  background: var(--gray6);\n  min-height: 100vh;\n\n  .container-fluid {\n    max-width: 1350px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
